import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import Styles from './Styles';
import {DownloadFile,ConfirmModal } from '../../../common';
import ACCESS_FORMS_CONSTANTS from './Constants';
import Cookies from 'js-cookie';
import { SessionStorageHelper } from 'utils/sessionHelper';
import { getSessionValues } from 'shared/Helpers/Utils';
import { setTokenCookie } from 'commonHelper/CommonHelperFunctions';
const FormList = props => {
    const {pdfUrlData,apiresponseStatus} = props;
    const [showForm94719Modal, setShowForm94719Modal] = useState(false);

   
    const modaldesc = (
  <>
    Thank you for your interest in the Distinguished Valor Matching Grant Program.
    We are not currently accepting applications. The application period runs annually
    from <b>January 1 through December 15</b>. Please check back on January 1, when
    the application period reopens.
  </>
);
    
    console.log('FormList received pdfUrlData:', pdfUrlData);
    console.log('FormList apiresponseStatus:', apiresponseStatus);
    
    const inlineStyle = {
        rating: {
            width: 14,
            height: 14,
        },
        ratingCol: { span: 1, offset: 1 },
        downloadFile: {
            fontWeight: 400,
            fontFamily: 'benton-sans',
            fontSize: 16,
            textAlign: 'left',
            marginTop: 0,
        },
    };

    const getKey = (item, index) => {
        return `${item}-${index}`;
    };

    const handleRedirectAEMForm = (item) => {
        const params = getSessionValues();
        const { vcmid, msrid, fismemberid} = params;
       
        const token = localStorage.getItem("token");
        const expiryEpochSeconds = localStorage.getItem("expiryEpochSeconds");
        console.log('token',token);
        
        // Use formUrl for Get Started, fallback to pdfPath if formUrl is not available
        let baseUrl = item?.formUrl;

        // Fix form URL by dynamically detecting the environment and setting correct base URL
        if (baseUrl) {
            const currentUrl = window.location.href;
            let formBaseUrl = '';
            if (currentUrl.includes('stage')) {
                formBaseUrl = 'https://stage.investor.vcm.com';
            } else if (currentUrl.includes('qa')) {
                formBaseUrl = 'https://qa.investor.vcm.com';
            } else if (currentUrl.includes('dev')) {
                formBaseUrl = 'https://dev.investor.vcm.com';
            } else {
                formBaseUrl = 'https://investor.vcm.com';
            }
            
            baseUrl = formBaseUrl + baseUrl;
        }

        const queryParams = new URLSearchParams();

        // if (token) queryParams.append("token", token);

        if(token) {
            setTokenCookie(token, expiryEpochSeconds)
        }
        queryParams.append("isMSR", "true");
        queryParams.append("channel", "msr");
        if (vcmid) queryParams.append("vcmid", vcmid);
        if (msrid) queryParams.append("msrid", msrid);
        if (fismemberid) queryParams.append("fismemberid", fismemberid);

        const finalUrl =
            baseUrl + (baseUrl.includes("?") ? "&" : "?") + queryParams.toString();

        setTimeout(() => {
            window.open(finalUrl, "_blank", "noopener,noreferrer");
        }, 1000);
    };

    const isForm94719RestrictedPeriod = () => {
    const today = new Date();

    const startDate = new Date(today.getFullYear(), 11, 16); // December 16
    const endDate = new Date(today.getFullYear(), 11, 31, 23, 59, 59); // December 31

    return today >= startDate && today <= endDate;
    };

   const handleGetStartedModal = (item) => {
    if (
        String(item.formID) === '94719' &&
        isForm94719RestrictedPeriod()
    ) {
        setShowForm94719Modal(true);
        return;
    }

    handleRedirectAEMForm(item);
    };

 

    const closeForm94719Modal = () => {
        setShowForm94719Modal(false);
    };

    return (
        <Styles.Forms data-testid="form-list">
            <>
            {showForm94719Modal && (

             <ConfirmModal
                modalTitle={'Notice'}
                modalBodyText={modaldesc}  
                onPrimaryClick={closeForm94719Modal}
                primaryButtonText={"OK"}
            />
            // <div
            //     id="form94719Modal"
            //     className="modal-overlay"
            //     onClick={(e) => {
            //         if (e.target.id === 'form94719Modal') {
            //             closeForm94719Modal();
            //         }
            //     }}
            // >
            //     <div className="modal-content">
            //         <button
            //             className="form-modal-close"
            //             onClick={closeForm94719Modal}
            //         >
            //             ×
            //         </button>

            //         <p>
            //             Thank you for your interest in the Distinguished Valor Matching
            //             Grant Program. We are not currently accepting applications for
            //             the 2026 program year. Please check back on January 1, 2027,
            //             when the application period will reopen.
            //         </p>

            //         <button
            //             id="form94719OkBtn"
            //             onClick={closeForm94719Modal}
            //         >
            //             OK
            //         </button>
            //     </div>
            // </div>
            )}
            {(pdfUrlData.length > 0 ) &&  
                pdfUrlData.map((item, index) => {
                    console.log(`Rendering form item ${index}:`, {
                        formID: item.formID,
                        title: item.pdfTitle,
                        showAsForm: item.showAsForm,
                        showAsDownload: item.showAsDownload
                    });
                    
                    return (
                    <Styles.FormItem key={getKey('form-key', index)} className="form-row d-flex" style={{ marginBottom: '1.5rem' }}>
                        <Col sm={2}>{item.formID}</Col>
                        <Col sm={8}>
                            <Styles.SubTitle>{item.pdfTitle}</Styles.SubTitle>
                            <p>{item.pdfDescription}</p>
                        </Col>
                        <Col sm={2}>
                            <Styles.LinkIconDiv>
                                {item?.showAsForm && item?.showAsDownload && (
                                    <>
                                        <span style={{color: '#004a98', textDecoration: 'underline', cursor: 'pointer', marginLeft:'1.25rem', fontWeight: '400', marginBottom: '0.625rem', display: 'block'}} onClick={() => handleGetStartedModal(item)}>Get Started <img src={'/assets/RightArrow.png'} style={{marginLeft:'0.3125rem', height:'17px'}} /></span>
                                        <DownloadFile
                                            saveAs={item.pdfPath}
                                            linkStyle={inlineStyle.downloadFile}
                                            text={'Download'}
                                            iconSrc={'/assets/icon_pdf.png'}
                                            downloadUrl={item.pdfPath}
                                            formID={item.formID}
                                            pdfTitle={item.pdfTitle}
                                        />
                                    </>
                                )}
                                {item?.showAsForm && !item?.showAsDownload && (
                                    <span style={{color: '#004a98', textDecoration: 'underline', cursor: 'pointer', marginLeft:'1.25rem', fontWeight: '400', marginBottom: '0.625rem'}} onClick={() => handleGetStartedModal(item)}>Get Started <img src={'/assets/RightArrow.png'} style={{marginLeft:'0.3125rem', height:'17px'}} /></span>
                                )}
                                {!item?.showAsForm && item?.showAsDownload && (
                                    <DownloadFile
                                        saveAs={item.pdfPath}
                                        linkStyle={inlineStyle.downloadFile}
                                        text={'Download'}
                                        iconSrc={'/assets/icon_pdf.png'}
                                        downloadUrl={item.pdfPath}
                                        formID={item.formID}
                                        pdfTitle={item.pdfTitle}
                                    />
                                )}
                                {!item?.showAsForm && !item?.showAsDownload && (
                                    <DownloadFile
                                        saveAs={item.pdfPath}
                                        linkStyle={inlineStyle.downloadFile}
                                        text={'Download'}
                                        iconSrc={'/assets/icon_pdf.png'}
                                        downloadUrl={item.pdfPath}
                                        formID={item.formID}
                                        pdfTitle={item.pdfTitle}
                                    />
                                )}
                            </Styles.LinkIconDiv>
                        </Col>
                    </Styles.FormItem>
                    );
                }
                )}
            </>

            <>
                  {(apiresponseStatus == true && pdfUrlData.length == 0 )  &&
                        <Styles.NoRecords>{ACCESS_FORMS_CONSTANTS.NO_RECORDS_FOUND}</Styles.NoRecords>
                  }
            </>
        </Styles.Forms>
    );
};

FormList.propTypes = {
    pdfUrlData: PropTypes.arrayOf(PropTypes.object),
};

FormList.defaultProps = {
    pdfUrlData: [],
};

export default FormList;
